import styles from './spinner.module.css';

type SpinnerSize = 'small' | 'medium';

type SpinnerProps = {
  size?: SpinnerSize;
  label?: string;
};

export const Spinner = ({ size = 'medium', label }: SpinnerProps) => {
  const isDecorative = label === undefined;

  return (
    <span
      className={`${styles.spinner} ${styles[size]}`}
      role={isDecorative ? undefined : 'status'}
      aria-label={label}
      aria-hidden={isDecorative}
    />
  );
};
